import { useQuery } from '@tanstack/react-query';
import { type AxiosError } from 'axios';

import type { LandingPageTypeDto } from '@/api/generated/models';

import { QueryKeyEnum } from '@/api/model/QueryKey.enum';
import { useApiClient } from '@/api/util/useApiClient.util';

interface Params {
  enabled?: boolean;
  userId: string;
}

interface Return {
  isError: boolean;
  isLoading: boolean;
  landingPage: LandingPageTypeDto | undefined;
}

export const useGetUserLandingPage = ({ enabled = true, userId }: Params): Return => {
  const { userLandingPagePreferenceRestApi } = useApiClient();

  const { data, isError, isLoading } = useQuery<LandingPageTypeDto, AxiosError>({
    enabled: enabled && Boolean(userId),
    queryFn: async () => {
      const response = await userLandingPagePreferenceRestApi.getUserLandingPagePreference(userId);
      return response.data.landingPageType;
    },
    queryKey: [QueryKeyEnum.USERS.LANDING_PAGE, userId],
  });

  return {
    isError,
    isLoading,
    landingPage: data,
  };
};
